import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import cx from "classnames";
import DecimalInput from "../DecimalInput";
import { ScreenReaderLabel } from "@ww-digital/web-foundations-react/modules";
import FormErrorMessage from "../../FormErrorMessage";
import isOutOfBounds from "../../../utils/isOutOfBounds";
import useEvent from "../../../utils/useEvent";
import useForceValidate from "../../../utils/useForceValidate";
import useAppContext from "../../AppContext";

const IntegerInput = ({
  name,
  label,
  value,
  onChange,
  styles: parentStyles,
  min,
  max,
  errorMessage,
  withAutofocus = true,
  disabled = false,
  placeholder = ""
}) => {
  const [hasError, setError] = useState(false);
  const { newQuiz, forceValidation } = useAppContext();

  const { hasTriggered } = useForceValidate({
    trigger: forceValidation,
    validate: () => {
      const isInvalid = isHeightInvalid(value);
      setError(isInvalid);
    }
  });

  const isHeightInvalid = height =>
    height === null || isOutOfBounds(height, min, max);

  const handleChange = (_, value) => {
    const isInvalid = isHeightInvalid(value);
    setError(isInvalid);
    onChange(isInvalid ? null : value);
  };

  const { listen } = useEvent("SettingsValidation");
  useEffect(() => {
    return listen(() => {
      setError(value === null || isOutOfBounds(value, min, max));
    });
  }, [listen, min, max, value]);

  const renderError =
    !disabled && hasError && (newQuiz.isSequence ? hasTriggered : true);

  return (
    <>
      <div
        className={cx(
          styles.singleInputContainer,
          styles.appendedLabel,
          parentStyles.fieldsetWrapperNewQuiz
        )}
      >
        <div className={styles.metric}>
          <DecimalInput
            id={name}
            aria-required={true}
            market="US"
            mask="000"
            error={hasError}
            defaultValue={value ?? ""}
            onChange={handleChange}
            autoFocus={withAutofocus}
            disabled={disabled}
            placeholder={placeholder}
          />
          <label
            className={cx(styles.tailingLabel, parentStyles.inputLabelNewQuiz)}
            htmlFor={name}
          >
            {label}
          </label>
          {hasError && (
            <ScreenReaderLabel role="alert">
              {label} input of {value} must be between {min} and {max}
            </ScreenReaderLabel>
          )}
        </div>
      </div>
      {renderError && (
        <FormErrorMessage role="alert">{errorMessage}</FormErrorMessage>
      )}
    </>
  );
};

export default IntegerInput;
